function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M12.78,20.774C8.962,27.4,11.389,37.453,15.611,43.549c2.107,3.048,4.24,5.783,7.163,5.783l.167,0a8.851,8.851,0,0,0,3.324-.887,9.11,9.11,0,0,1,3.938-.933,8.569,8.569,0,0,1,3.749.9,7.934,7.934,0,0,0,3.591.862c3.292-.061,5.313-3.014,7.1-5.618a24.881,24.881,0,0,0,3.109-6.369l.013-.039a.369.369,0,0,0-.2-.454l-.027-.012a9.435,9.435,0,0,1-5.718-8.642,9.714,9.714,0,0,1,4.589-8.119L46.444,20a.374.374,0,0,0,.163-.239.368.368,0,0,0-.058-.281,10.68,10.68,0,0,0-8.4-4.562,7.26,7.26,0,0,0-.733-.036A14.642,14.642,0,0,0,32.143,16.2a8.461,8.461,0,0,1-2.525.755A8.259,8.259,0,0,1,27,16.188a12.67,12.67,0,0,0-4.605-1.17h-.117A11.291,11.291,0,0,0,12.78,20.774Z",
  transform: "translate(-10.875 -4.173)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M35.7,5.634a10.308,10.308,0,0,0-6.807,3.491,9.662,9.662,0,0,0-2.446,7.163.371.371,0,0,0,.338.321c.157.013.318.019.479.019a8.721,8.721,0,0,0,6.425-3.3,10.19,10.19,0,0,0,2.393-7.369A.373.373,0,0,0,35.7,5.634Z",
  transform: "translate(-8.425 -5.634)"
});

var SvgIos = function SvgIos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_1222",
    "data-name": "Group 1222",
    width: 36.905,
    height: 45.159,
    viewBox: "0 0 36.905 45.159",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IOS.31a21f31.svg";
export { ForwardRef as ReactComponent };